/** RANDOMISE LINK IN "THINGS TO DO IN THE VALLEY" */
function randomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var links = ['/eat','/shop','/play'];
var jqwait = setTimeout(function(){
  if ( typeof(jQuery) !== 'undefined' ){
    clearTimeout(jqwait);
    jQuery('.js-link-things-to-do').attr('href', links[randomInteger(0,2)]);
  }
}, 1000);